import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import MenuViewModel from '../../services/menu/MenuViewModel';
import UniqueId from '../../services/uid/UniqueId';

import {
  emptyAction,
  failureAction,
  pendingAction,
  successAction,
} from './actionHandler';
import session from './session';

export interface MenuState extends MenuViewModel {
  filter: string;
  opened: boolean;
  currentOpenedId: UniqueId | null;
}

const initialState: MenuState = {
  application: '',
  filter: '',
  items: {},
  opened: false,
  currentOpenedId: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    get: pendingAction<MenuState, { application: string }>(),
    getSuccess: successAction<MenuState, { menu: MenuViewModel }>(
      (state, { payload: { menu } }) => {
        const { application, items } = menu;

        state.application = application;
        state.items = items;
      }
    ),
    getFailure: failureAction(),
    filter(state, { payload: { filter } }: PayloadAction<{ filter: string }>) {
      state.filter = filter;
    },
    submitSearch: emptyAction(),
    toggleOpened(state, { payload }: PayloadAction<boolean | undefined>) {
      state.opened = payload ?? !state.opened;
    },
    setCurrentOpenedId(state, { payload }: PayloadAction<UniqueId | null>) {
      state.currentOpenedId = payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(session.signOutSuccess, () => initialState);
  },
});

export const menuReducer = menuSlice.reducer;

export default menuSlice.actions;
